import { Localization } from "@viamap/viamap2-common";
import { Fragment, useState } from "react";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton } from "./GlassButtons";
import { GlassInputControl, GlassInputGroup, GlassTextInputTransformer } from "./GlassInput";
import { ManagedWindow } from "src/WindowManager/WindowState";


type Props = {
  managedWindow: ManagedWindow;
  defaultNames: string[];
  onConfirm: (names: string[]) => void;
  onClose: () => void;
};
export function NameOnExport(props: Props) {
  const [names, setNames] = useState<string[]>(props.defaultNames.map(() => ""));

  function updateName(value: string, idx: number) {
    setNames((prevNames) => prevNames.map((name, idy) => idx === idy ? (value ?? "") : name))
  }

  function Accept() {
    props.onConfirm(names.map((name, idx) => name || props.defaultNames[idx]));
    props.onClose()
  }

  function Cancel() {
    props.onClose()
  }


  return <AdvancedDragModal
    window={props.managedWindow}
    PosDefault={{ left: "50%", top: "10%", transform: "translateX(-50%)", width: "500px" }}
    title={Localization.getText("Rename")}
  >
    <ADModalInfo>
      {names.length < 2 ? Localization.getText("Name the generated export") : Localization.getText("Name the generated exports")}
    </ADModalInfo>
    <ADModalBody>
      <GlassInputGroup autoFocus={true}
        onSubmit={Accept}
        onEscape={Cancel}
      >
        {names.map((layer, idx) => {
          return (<Fragment key={props.defaultNames[idx]}>
            <GlassTextInputTransformer label={(props.defaultNames[idx])}>
              <GlassInputControl>
                <input autoFocus={idx == 0} style={{ color: "black", paddingLeft: "6px" }} type="text" value={names[idx]} placeholder={props.defaultNames[idx]} onChange={(ev) => updateName(ev.target.value, idx)} />
              </GlassInputControl>
            </GlassTextInputTransformer>
          </Fragment>)
        })}
      </GlassInputGroup>
    </ADModalBody>
    <ADModalFooter>
      <GlassButton onClick={() => Accept()}>{Localization.getText("Save")}</GlassButton>
      <GlassButton onClick={() => Cancel()}>{Localization.getText("Close")}</GlassButton>
    </ADModalFooter>
  </AdvancedDragModal>
}